import React, { useEffect, useState, useCallback } from "react"
import { Col, Row, Card } from "react-bootstrap"
import { EmailLogColumns, EmailLogFilters } from 'constants/application'
import FilterBarModule from "components/shared/FilterBarModule"
import TableComponent from 'components/shared/TableComponent'
import { getEmailLogs } from 'actions/emailLogs'
import { useDispatch } from 'react-redux'
import strings from "strings"
import "./EmailLog.scss"

function EmailLog() {
  const dispatch = useDispatch()
  const [emailLogs, setEmailLogs] = useState([])
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({})
  const [filter, setFilter] = useState({})
  const [totalRecords, setTotalRecords] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [columns, setColumns] = useState([...EmailLogColumns])

  const getEmailLogsData = useCallback((pagination = {}, filters = {}) => {
    setLoading(true)
    dispatch(getEmailLogs(pagination, filters))
      .then((result) => {
        setEmailLogs(result.data)
        setTotalRecords(result.pagination.totalRecords)
        setTotalPages(result.pagination.totalPages)
      })
      .catch((error) => {
        console.error('Error fetching Email logs:', error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [dispatch])

  useEffect(() => {
    const filterPayload = { ...filter }
    getEmailLogsData(pagination, filterPayload)
  }, [getEmailLogsData, pagination, filter])

  return (
    <div id="email-logs">
      <Row className='mb-3'>
        <Col xs={12} className="text-left">
          <h4>{strings.EMAIL_LOGS}</h4>
        </Col>
      </Row>
      <Row className="ml-0 mr-0">
        <Col className="pr-lg-0 pl-lg-0 cardBorder">
          <Card className="border-0">
            
            <div className="table-responsive">
              <TableComponent
                className='email-log-table'
                data={emailLogs}
                columns={columns}
                sort={true}
                loading={loading}
                totalRecords={totalRecords}
                totalPages={totalPages}
                onChangePagination={(pagination) => setPagination(pagination)}
                remoteSorting
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EmailLog 